
import { useStore } from "vuex";
import { computed, defineComponent, ref } from "vue";
import CharacterTable from "./CharacterTable.vue";
import CharStatsTable from "./CharStatsTable.vue";
import ResistanceTable from "./ResistanceTable.vue";
import GearTable from "./GearTable.vue";
import EquipPanel from "./EquipPanel.vue";
import GenericPanel from "../GenericPanel.vue";
import GenericButton from "../GenericButton.vue";



export default defineComponent({
  name: "CharStats",
  components: {
    CharacterTable,
    CharStatsTable,
    ResistanceTable,
    GearTable,
    EquipPanel,
    GenericPanel,
    GenericButton
},
  setup() {
    const store = useStore();
    const panelState = ref('default');
    const panelTitle = computed(() => {
      switch (panelState.value) {
        case 'head':
          return 'EQUIP HELMET';
        case 'body':
          return 'EQUIP ARMOR';
        default:
          return "CHAR STATS";
      } 
    });
    const equipGear = (slot: string) => {
      panelState.value = slot ? slot : 'default'
    };
    return {
      state: store.state,
      equipGear,
      panelState,
      panelTitle,
    };
  },
});
